import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../widgets';
import BotonComponent from '../dashboard/components/BotonNuevo';
import {
  allDireccionesAction,
  setActivoDireccionesAction,
} from './DireccionesAction';
import FormDirecciones from './components/FormDirecciones';
import ListadoDirecciones from './components/ListadoDirecciones';

const DireccionesView = ({ idUsuario, idEntidad }) => {
  const dispatch = Redux.useDispatch();

  const direccionesStore = Redux.useSelector((state) => state.direcciones);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {direccionesStore.all.length < 2 && (
          <BotonComponent
            click={async () => {
              await setActivoDireccionesAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            addIcon
            mr={2}
          />
        )}
        <BotonComponent
          click={async () => {
            await setActivoDireccionesAction(dispatch, null);
            await allDireccionesAction(dispatch, {
              ...direccionesStore.params,
              idUsuario,
              idEntidad,
            });
          }}
          disabled={
            direccionesStore.all.length === 0 && direccionesStore.loadingAll
          }
          white
          refreshIcon
          text={direccionesStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoDirecciones
          setOpenModalForm={(value) => setOpenModalForm(value)}
          params={{ idUsuario, idEntidad }}
        />
      </Grid>
      <ModalComponent
        id="modalFormDirecciones"
        title={
          direccionesStore.activo
            ? `Editar dirección: ${direccionesStore.activo.direccion}`
            : 'Nueva dirección'
        }
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormDirecciones
          activo={direccionesStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
          params={{ idUsuario, idEntidad }}
        />
      </ModalComponent>
    </Grid>
  );
};

export default DireccionesView;
